import { render, staticRenderFns } from "./FatjHome.vue?vue&type=template&id=cbcc1632&scoped=true"
import script from "./FatjHome.vue?vue&type=script&lang=js"
export * from "./FatjHome.vue?vue&type=script&lang=js"
import style0 from "./FatjHome.vue?vue&type=style&index=0&id=cbcc1632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcc1632",
  null
  
)

export default component.exports